import type {
    AiAgendaResponse,
    HandoutPreviewData,
    ReviewDiscussionData,
    ReviewDiscussionUpdatePayload,
    TranscriptUploadResponse,
} from '@/types/review/ReviewDiscussion';

import { api } from '@/api/api';

export default {
    async getOrCreateDiscussion(reviewInstanceId: string): Promise<ReviewDiscussionData> {
        const response = await api.get(`/reviewdiscussion/${reviewInstanceId}`);
        return response.data;
    },

    async updateDiscussion(
        reviewInstanceId: string,
        payload: ReviewDiscussionUpdatePayload,
    ): Promise<ReviewDiscussionData> {
        const response = await api.put(`/reviewdiscussion/${reviewInstanceId}`, payload);
        return response.data;
    },

    async getHandoutPreview(reviewInstanceId: string): Promise<HandoutPreviewData> {
        const response = await api.get(`/reviewdiscussion/${reviewInstanceId}/handout-preview`);
        return response.data;
    },

    async generateAgendaAi(reviewInstanceId: string): Promise<AiAgendaResponse> {
        const response = await api.post(`/reviewdiscussion/${reviewInstanceId}/generate-agenda-ai`);
        return response.data;
    },

    async uploadTranscript(
        reviewInstanceId: string,
        transcriptText: string,
    ): Promise<TranscriptUploadResponse> {
        const response = await api.post(
            `/reviewdiscussion/${reviewInstanceId}/upload-transcript`,
            transcriptText,
        );
        return response.data;
    },

    async completeEvaluation(reviewInstanceId: string): Promise<{ success: boolean }> {
        const response = await api.post(`/reviewdiscussion/${reviewInstanceId}/complete`);
        return response.data;
    },
};
